import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

export function Footer() {
  return (
    <footer className="bg-secondary text-white" data-testid="footer">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-heading text-xl md:text-3xl mb-2">Stay Updated</h3>
              <p className="text-white/70 font-body">Subscribe to our newsletter for exclusive deals and updates.</p>
            </div>
            <form className="flex flex-col sm:flex-row w-full md:w-auto gap-3">
              <Input
                type="email"
                placeholder="Enter your email"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50 rounded-full w-full sm:min-w-[280px]"
                data-testid="newsletter-email"
              />
              <Button className="bg-primary hover:bg-primary/90 text-white rounded-full px-8 w-full sm:w-auto" data-testid="newsletter-submit">
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center space-x-0 mb-6">
              <img
                src="/logo.png"
                alt="Nso-India"
                className="h-8 w-auto object-contain"
              />
            </Link>
            <p className="text-white/70 font-body mb-6 leading-relaxed">
              Premium shopping destination for optical eyewear, smartphones, and gift cards. Quality products, exceptional service.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-primary transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-primary transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-primary transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-primary transition-colors" data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3 font-body">
              <li><Link to="/about" className="text-white/70 hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/blog" className="text-white/70 hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/category/optical" className="text-white/70 hover:text-primary transition-colors">Optical</Link></li>
              <li><Link to="/category/mobile" className="text-white/70 hover:text-primary transition-colors">Mobile</Link></li>
              <li><Link to="/category/gift-cards" className="text-white/70 hover:text-primary transition-colors">Gift Cards</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-heading text-lg mb-6">Customer Service</h4>
            <ul className="space-y-3 font-body">
              <li><Link to="/contact" className="text-white/70 hover:text-primary transition-colors">Contact Us</Link></li>
              <li><Link to="/faq" className="text-white/70 hover:text-primary transition-colors">FAQs</Link></li>
              <li><Link to="/shipping" className="text-white/70 hover:text-primary transition-colors">Shipping Info</Link></li>
              <li><Link to="/returns" className="text-white/70 hover:text-primary transition-colors">Returns & Exchange</Link></li>
              <li><Link to="/track-order" className="text-white/70 hover:text-primary transition-colors">Track Order</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4 font-body">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-white/70">NSO Superstore, Sumitra Heights, Opp-New Court, Kachery Road, Uditnagar, Rourkela-769012, Odisha, INDIA</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <span className="text-white/70">+91 7077314444</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <span className="text-white/70">support@Nso-India.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm font-body">
              © 2026 Nso-India. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-4 gap-y-2 text-sm font-body">
              <Link to="/privacy" className="text-white/50 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-white/50 hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/cookies" className="text-white/50 hover:text-white transition-colors">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
